import {
  ChangeDetectionStrategy,
  Component,
  inject
} from '@angular/core';

import {
  ToastService
} from '../../services/toast.service';

@Component({
  selector: 'app-toast',
  standalone: true,
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToastComponent {

  protected readonly toastService =
    inject(ToastService);
}